import React, { useState, useEffect } from 'react';


export default function ImageChecker({ imageUrl, children }) {
    const [imageExists, setImageExists] = useState(true);

    useEffect(() => {
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        setImageExists(true);
      };
      img.onerror = () => {
        setImageExists(false);
      };
    }, [imageUrl]);
  return (
    <div>
        {imageExists ? children : null}
    </div>
  )
}
